import {
    VoucherNursingCareAssessmentExportInput,
} from './../../../../../../../../types/src/services/input-type/voucher/voucher-nursing-care-assessment.export-input';
import {
    VoucherNursingCareExportInput,
} from './../../../../../../../../types/src/services/input-type/voucher/voucher-nursing-care.export-input';
import { VoucherExportInput } from '@libs/types/src/services/input-type/voucher/voucher.export-input';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { VoucherExportDialogStore } from './voucher-export-dialog.store';
import { DynamicDialogConfig, DynamicDialogRef } from '@openng/optimus-ui/dynamicdialog';
import {
    BeforePrintDialogComponent,
    BeforePrintDialogResponse,
} from '../../common/before-print-dialog/before-print-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { BaseDialogComponent } from 'packages/client/src/app/components/kit/base-dialog/base-dialog.component';
import {
    PrintVoucherDialogComponent,
} from '../../../../../components/medical-service/voucher/print-voucher-dialog/print-voucher-dialog.component';
import {
    PrintDailyRecordDialogComponent,
} from 'packages/client/src/app/components/medical-service/voucher/print-daily-record-dialog/print-daily-record-dialog.component';
import { generateFilename } from '../../../../../utils/files.utils';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';
import { VoucherExportKind } from '@libs/types/src/notifications/types/background-action.types';

@Component({
    selector: 'app-voucher-export-dialog',
    templateUrl: 'voucher-export-dialog.component.html',
    styleUrls: ['voucher-export-dialog.component.scss'],
    providers: [VoucherExportDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ButtonComponent],
})
export class VoucherExportDialogComponent extends BaseDialogComponent {

    public readonly selfRef = inject(DynamicDialogRef);
    public readonly config = inject(DynamicDialogConfig);
    protected readonly store = inject(VoucherExportDialogStore);
    protected readonly dialogService = inject(BaseDialogService);
    protected readonly translate = inject(TranslateService);

    voucherId: number | null = null;
    serviceId: number | null = null;
    childRef: DynamicDialogRef | undefined;

    ngOnInit(): void {
        this.voucherId = this.config.data.voucherId;
        this.serviceId = this.config.data.serviceId;
    }

    printVoucher() {
        this.dialogService.open(
            PrintVoucherDialogComponent,
            {
                header: this.translate.instant('common.export'),
                data: { serviceId: this.serviceId, voucherIds: [this.voucherId] },
            },
        );
    }

    printNursingCare() {
        this.childRef = this.dialogService.open(BeforePrintDialogComponent, {
            header: this.translate.instant('common.export'),
            data: { archive: true },
        });
        this.childRef.onClose.subscribe(async (data: BeforePrintDialogResponse) => {
            if (data) {
                const exportInput: VoucherNursingCareExportInput = {
                    filename: generateFilename('voucher.nursingCare.label'),
                    voucherId: this.voucherId,
                    ...data,
                };

                await this.store.start({
                    kind: VoucherExportKind.NURSING_CARE,
                    input: exportInput,
                });
            }
        });
        this.selfRef.close();
    }

    printDailyRecords() {
        this.childRef = this.dialogService.open(PrintDailyRecordDialogComponent, { header: this.translate.instant('common.export') });
        this.childRef.onClose.subscribe(async (data: BeforePrintDialogResponse) => {
            if (data) {
                const exportInput: VoucherExportInput = {
                    filename: generateFilename('workData.dailyRecord.labelMulti'),
                    voucherId: this.voucherId,
                    ...data,
                };

                await this.store.start({
                    kind: VoucherExportKind.DAILY_RECORDS,
                    input: exportInput,
                });
            }
        });
        this.selfRef.close();
    }

    printAssessment() {
        this.childRef = this.dialogService.open(BeforePrintDialogComponent, {
            header: this.translate.instant('common.export'),
            data: { archive: true },
        });
        this.childRef.onClose.subscribe(async (data: BeforePrintDialogResponse) => {
            if (data) {
                const exportInput: VoucherNursingCareAssessmentExportInput = {
                    filename: generateFilename('voucher.nursingCare.fields.assessments'),
                    voucherId: this.voucherId,
                    ...data,
                };

                await this.store.start({
                    kind: VoucherExportKind.ASSESSMENT,
                    input: exportInput,
                });
            }
        });
        this.selfRef.close();
    }

}
